// @flow
import * as React from "react"
import DateTile from "components/ReservationList/ReservationTile/DateTile"
import { ReservationTileWrap, Body, ArrowWrap } from "./styled"
import ProductPreview from "components/ProductPreview"
import type { Reservation } from "data/reservations/types"
import type { PendingReservation } from "data/basket/types"
import { reservationStatuses } from "data/reservations/constants"
import ArrowIcon from "assets/icons/ArrowIcon"

type Props = {|
  pendingReservation: PendingReservation,
|}

const ReservationTile = ({ pendingReservation }: Props) => {

  return (
    <ReservationTileWrap stack>
      <DateTile start={pendingReservation.start} end={pendingReservation.end} />
      <Body>
        <ProductPreview
          productVariant={pendingReservation.productVariant}
          affiliateName={pendingReservation.affiliate.name}
        />
      </Body>
    </ReservationTileWrap>
  )
}

export default ReservationTile



// WEBPACK FOOTER //
// ./src/pages/ShoppingBasket/BasketTile/index.js